// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 58165) return "static/chunks/" + chunkId + "-7fbc7f082c4526b3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "82454ed570a169df" + ".js";
};